import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const unread = items.filter((n) => !n.read).length;

  const load = () => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const click = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", click);
    return () => document.removeEventListener("mousedown", click);
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div ref={ref} className="relative" data-testid="notification-bell">
      <button onClick={() => setOpen(!open)} className="relative p-2 rounded-lg hover:bg-slate-100" data-testid="notification-toggle">
        <Bell size={18} className="text-slate-700"/>
        {unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 bg-rose-600 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 grid place-items-center" data-testid="notification-unread-count">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white border border-slate-200 rounded-xl shadow-lg z-50">
          <div className="px-4 py-2.5 border-b border-slate-200 flex items-center justify-between">
            <div className="font-medium text-sm text-slate-900">Notifications</div>
            {unread > 0 && (
              <button onClick={markAll} className="text-xs text-sky-700 hover:text-sky-900" data-testid="mark-all-read">
                Mark all read
              </button>
            )}
          </div>
          <div className="max-h-80 overflow-y-auto">
            {items.length === 0 ? (
              <div className="px-4 py-6 text-center text-sm text-slate-500">No notifications.</div>
            ) : items.map((n) => (
              <div key={n.id} className={`px-4 py-2.5 border-b border-slate-100 ${n.read ? "" : "bg-sky-50/40"}`} data-testid={`notification-${n.id}`}>
                <div className="text-sm text-slate-800">{n.message}</div>
                <div className="text-[11px] text-slate-500 mt-0.5">{n.created_at?.slice(0, 19).replace("T", " ")}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
